import React from "react";

function ButtonPreloader(props) {
  const {children} = props;

  return (
    <button {...props}>
      { children }
      <span className="preloader preloader--dots">
        <span className="dots"/>
      </span>
    </button>
  );
}

export default ButtonPreloader;